import React from 'react';
import {
  HeaderWrapper,
  ValueWrapper,
  TitleWrapper,
  IconWrap,
  SecondRow,
} from '@components/metrics-panel-hz/MetricCard/styled';
import { Tooltip, Divider } from 'antd';
import {
  useGetDataForMetric,
  useGetPlanLimitForMetric,
} from '@src/components/usage-dashboard/hooks/useMetricSeries';
import { humanize } from '@utils';
import { InfoCircleOutlined } from '@ant-design/icons';
import { usageMetricList } from '@src/components/usage-dashboard/atoms';
import {
  getUsageMetricsMeta,
  isNoPlanLimitMetric,
  isPlanLimitZero,
} from '@src/components/usage-dashboard/hooks/utils';

const Header = ({ metric }) => {
  const { data }: any = useGetDataForMetric(metric);
  const { data: planLimitData }: any = useGetPlanLimitForMetric(metric);
  const { total } = data;
  const { total: planLimitTotalData } = planLimitData;
  const usageMetricsMeta = getUsageMetricsMeta();
  const displayTotal = (value) => {
    const result = humanize(value, usageMetricsMeta[metric].unit);
    if (result === null) {
      return '';
    }
    return `${result} ${usageMetricList[metric].localUnit}`;
  };

  const showLimitLabel =
    !isNoPlanLimitMetric(metric) && !isPlanLimitZero(planLimitData) && displayTotal(total) !== '';
  const limitText = ['RealtimeAPICalls', 'HistoricalAPICalls'].includes(metric)
    ? 'Daily Limit'
    : 'Limit';

  return (
    <HeaderWrapper>
      <TitleWrapper>
        <h4 style={{ marginBottom: 0 }}>
          {usageMetricList[metric].displayName}
          <IconWrap>
            {usageMetricList[metric].tooltipText ? (
              <Tooltip title={usageMetricList[metric].tooltipText}>
                <InfoCircleOutlined />
              </Tooltip>
            ) : (
              ''
            )}
          </IconWrap>
        </h4>
      </TitleWrapper>
      <SecondRow>
        <ValueWrapper>
          <Tooltip title={total ? `${total.toFixed(2)} ${usageMetricList[metric].localUnit}` : ''}>
            {displayTotal(total)}
          </Tooltip>
        </ValueWrapper>
        {showLimitLabel ? (
          <>
            <Divider type="vertical" style={{ height: 24 }} />
            <ValueWrapper style={{ whiteSpace: 'pre-wrap' }}>
              <Divider
                style={{
                  borderColor: '#FF4D4F',
                  borderWidth: 1,
                  margin: 0,
                  minWidth: 24,
                  width: 24,
                }}
                variant="dashed"
                dashed
              />
              <span> {limitText} </span>
              <span style={{ minWdith: 50 }}>{displayTotal(planLimitTotalData)}</span>
            </ValueWrapper>
          </>
        ) : null}
      </SecondRow>
    </HeaderWrapper>
  );
};

export default Header;
